import React from 'react'

import { SidebarLoadingPage } from './SidebarLoadingPage'

export const ArtboardDetailsLoadingPage = () => {
  return <SidebarLoadingPage footer={null} />
}
